import styled from 'styled-components';
import theme from '../../../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;

  & .main-icon {
    width: 112px;
  }

  & .title {
    font-weight: 500;
    font-size: 22px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }

  & .tel {
    font-weight: 600;
    font-size: 16px;
    color: var(--blue-einstein);
    line-height: 24px;
  }

  & .row {
    display: flex;
    flex-direction: row;

    .line-base {
      position: relative;
    }

    &:not(:last-child) {
      .line {
        position: absolute;
        background-color: #d5d5d6;
        width: 2.5px;
        height: 100%;
        left: 50%;
        z-index: -1;
      }
    }

    img {
      width: 40px;
    }

    .info {
      padding-left: 20px;
      color: ${theme.colors.colorGray400};
      font-size: 14px;
      padding-bottom: 40px;
    }
  }
`;

export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;

  img {
    width: 56px;
    height: 56px;
  }
`;

export const InfoContainer = styled.div``;

export const ProductName = styled.h5`
  color: #555658;
  font-size: 18px;
  font-weight: 500;
  margin: 7px 0;
`;

export const Link = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    color: var(--blue-einstein);
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-decoration: none;
  }

  svg {
    width: 12px;
    fill: var(--blue-einstein);
  }
`;

export const Price = styled.p`
  color: #555658;
  font-size: 18px;
  font-weight: 500;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: space-between;
  margin-top: 24px;

  @media (min-width: 900px) {
    margin-top: 40px;
  }
`;

export const BodyWrapper = styled.div``;

export const Info = styled.div`
  color: #898b8e;
  font-size: 14px;
  font-weight: 400;

  margin-top: 16px;
`;

export const GridContador = styled.div``;

export const DescriptonServiceItem = styled.div`
  color: #898b8e;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
  text-align: justify;
  text-justify: inter-character;
`;

export const CloseWrapper = styled.div`
  & div {
    display: flex;
    gap: 8px;
    cursor: pointer;
  }
`;

export const CloseIcon = styled.img`
  cursor: pointer;
`;

export const CloseTitle = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: #555658;
`;

export const WrapperInfo = styled.div`
  margin-top: 24px;

  @media (min-width: 900px) {
    margin-top: 40px;
  }
`;

interface ButtonWrapper {
  showPrices: boolean | undefined;
}

export const ButtonWrapper = styled.div<ButtonWrapper>`
  margin-top: ${props => (props.showPrices ? '55px' : '64px')};

  @media (min-width: 900px) {
    margin-top: 0;
    padding: 24px 0;
  }
`;
